module.exports = __webpack_public_path__ + "dk.85d27644.svg";